<script>
	import { Link, navigate } from 'svelte-routing';
	import { cartStore } from '../stores/cart.store';
	import { currencyFormatter } from '../lib/utils';
	import { placeOrder } from '../stores/order.store';
	let address = {
		name: '',
		email: '',
		phone: '',
		address: '',
		city: '',
		country: '',
		postal: '',
	};
	const onChanges = (e) => {
		address = {
			...address,
			[e.target.name]: e.target.value,
		};
	};
	const onPlaceOrder = (e) => {
		e.preventDefault();
		const order = {
			...address,
			items: $cartStore,
			total: $cartStore.reduce(
				(acc, curr) => acc + curr.price * curr.quantity,
				0
			),
		};
		placeOrder(order);
		navigate('/orders-list');
	};
</script>

<section class="section">
	<div class="content">
		<section class="checkout-details">
			<div class="order-summary">
				<h1>Order Summary</h1>
			</div>
			<div class="checkout-details-inner">
				<div class="checkout-lists">
					{#each $cartStore as item}
						<div class="card">
							<div class="card-image">
								<img src={item.imgSrc} alt="" />
							</div>
							<div class="card-details">
								<div class="card-name">
									{item.name}
								</div>
								<div class="card-price">
									{currencyFormatter.format(item.price)}
								</div>
								<span class="qty">Quality: {item.quantity}</span>
							</div>
						</div>
					{/each}
				</div>
				<div class="checkout-shipping">
					<h5>Items</h5>
					<p>
						{$cartStore.reduce((acc, curr) => acc + curr.quantity, 0)}
					</p>
				</div>
				<div class="checkout-total">
					<h5>Total</h5>
					<p>
						{currencyFormatter.format(
							$cartStore.reduce(
								(acc, curr) => acc + curr.price * curr.quantity,
								0
							) + 0
						)}
					</p>
				</div>
			</div>
		</section>
		<section class="checkout-form">
			<form on:submit={onPlaceOrder}>
				<h6>Contact information</h6>
				<div class="form-control">
					<label for="checkout-name">Full name</label>
					<div>
						<input
							bind:value={address.name}
							on:change={onChanges}
							type="text"
							id="checkout-name"
							name="name"
							placeholder="Enter you name..."
							required
						/>
					</div>
				</div>
				<div class="form-control">
					<label for="checkout-email">E-mail</label>
					<div>
						<input
							bind:value={address.email}
							on:change={onChanges}
							type="email"
							id="checkout-email"
							name="email"
							placeholder="Enter your email..."
							required
						/>
					</div>
				</div>
				<div class="form-control">
					<label for="checkout-phone">Phone</label>
					<div>
						<input
							bind:value={address.phone}
							on:change={onChanges}
							type="tel"
							name="phone"
							id="checkout-phone"
							placeholder="Enter you phone..."
							required
						/>
					</div>
				</div>
				<br />
				<div class="form-control">
					<label for="checkout-address">Address</label>
					<div>
						<input
							bind:value={address.address}
							on:change={onChanges}
							type="text"
							name="address"
							id="checkout-address"
							placeholder="Your address..."
							required
						/>
					</div>
				</div>
				<div class="form-control">
					<label for="checkout-city">City</label>
					<div>
						<input
							bind:value={address.city}
							on:change={onChanges}
							type="text"
							name="city"
							id="checkout-city"
							placeholder="Your city..."
							required
						/>
					</div>
				</div>
				<div class="form-group">
					<div class="form-control">
						<label for="checkout-country">Country</label>
						<div>
							<input
								bind:value={address.country}
								on:change={onChanges}
								type="text"
								name="country"
								id="checkout-country"
								placeholder="Your country..."
								list="country-list"
								required
							/>
						</div>
					</div>
					<div class="form-control">
						<label for="checkout-postal">Postal code</label>
						<div>
							<input
								bind:value={address.postal}
								on:change={onChanges}
								type="numeric"
								name="postal"
								id="checkout-postal"
								placeholder="Your postal code..."
								required
							/>
						</div>
					</div>
				</div>
				<div class="form-control-btn">
					<button on:submit={onPlaceOrder} class="btn-checkout"
						>Place order</button
					>
				</div>
			</form>
		</section>
	</div>
</section>

<style>
	.btn-checkout {
		background-color: #045b64;
		color: white;
		border: none;
		border-radius: 5px;
		padding: 10px 20px;
		font-size: 16px;
		font-weight: 500;
		cursor: pointer;
		display: block;
		width: 100%;
		margin-top: 30px;
	}
	.content {
		display: flex;
		justify-content: space-between;
		max-width: 1000px;
		margin: 0 auto;
	}
	.checkout-form {
		width: 50%;
	}
	.qty {
		margin-top: 10px;
		font-size: 12px;
		font-weight: 500;
		color: #828282;
	}
	form h6 {
		font-size: 25px;
		font-weight: 500;
	}
	.form-control {
		margin: 10px 0px;
		position: relative;
	}
	label:not([for='checkout-checkbox']) {
		display: block;
		font-size: 10px;
		font-weight: 500;
		margin-bottom: 2px;
	}
	input:not([type='checkbox']) {
		width: 100%;
		padding: 10px 10px 10px 40px;
		border-radius: 10px;
		outline: none;
		border: 0.2px solid #4e515085;
		font-size: 12px;
		font-weight: 700;
	}
	input:not([type='checkbox'])::placeholder {
		font-size: 12px;
		font-weight: 500;
	}
	.form-control label {
		font-size: 14px;
		font-weight: 300;
		margin-bottom: 10px;
	}
	label[for='checkout-checkbox'] {
		font-size: 12px;
		font-weight: 400;
		line-height: 10px;
		margin-top: 10px;
	}
	.form-control > div {
		position: relative;
	}
	.form-group {
		display: flex;
		column-gap: 25px;
	}
	.checkbox-control {
		display: flex;
		align-items: center;
		column-gap: 10px;
	}
	.form-control-btn {
		display: flex;
		align-items: center;
		justify-content: flex-end;
		color: #fff;
	}
	.form-control-btn button {
		padding: 10px 25px;
		font-size: 16px;
		color: #fff;
		background-color: var(--green);
		border: 0;
		border-radius: 7px;
		letter-spacing: 0.5px;
		font-weight: 200;
		cursor: pointer;
	}
	.form-control-btn button:hover {
		background-color: #045b64;
	}
	.checkout-details {
		width: 40%;
	}
	.order-summary h1 {
		font-size: 25px;
		font-weight: 500;
		margin-bottom: 30px;
	}
	.checkout-details-inner {
		background: #f2f2f2;
		border-radius: 10px;
		padding: 20px;
	}
	.checkout-lists {
		display: flex;
		flex-direction: column;
		row-gap: 15px;
		margin-bottom: 40px;
	}
	.card {
		width: 100%;
		display: flex;
		column-gap: 15px;
	}
	.card-image {
		width: 150px;
		height: 200px;
	}
	.card-image img {
		width: 100%;
		height: 100%;
		object-fit: fill;
		border-radius: 10px;
	}
	.card-details {
		display: flex;
		flex-direction: column;
	}
	.card-name {
		font-size: 16px;
		font-weight: 400;
	}
	.card-price {
		font-size: 14px;
		font-weight: 500;
		color: #f2994a;
		margin-top: 5px;
	}
	.card-price span {
		color: #4e5150;
		text-decoration: line-through;
		margin-left: 10px;
	}
	.card-wheel {
		margin-top: 17px;
		border: 0.2px solid #4e515085;
		width: 90px;
		padding: 8px 8px;
		border-radius: 10px;
		font-size: 12px;
		display: flex;
		justify-content: space-between;
	}
	.card-wheel button {
		background: #e0e0e0;
		color: #828282;
		width: 15px;
		height: 15px;
		display: flex;
		justify-content: center;
		align-items: center;
		border: 0;
		cursor: pointer;
		border-radius: 3px;
		font-weight: 500;
	}
	.checkout-shipping,
	.checkout-total {
		display: flex;
		padding: 5px 0px;
		border-top: 1px solid #bdbdbd;
		justify-content: space-between;
	}
	.checkout-shipping h5,
	.checkout-total h5 {
		font-size: 18px;
		font-weight: 400;
	}
	.checkout-total p {
		font-size: 16px;
		font-weight: 500;
	}
	@media screen and (max-width: 768px) {
		.content {
			flex-direction: column;
			height: auto;
			margin-bottom: 50px;
			padding: 5px;
		}
		.checkout-form {
			width: 100%;
			margin-top: 35px;
		}
		.checkout-details {
			width: 100%;
		}
	}
</style>
